import { mutationEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { httpGetWorkspace } from 'services/backofficeIntegration/http/endpoints/workspace/httpGetWorkspace';
import { httpGetWorkspaceMembersOfWorkspace } from 'services/backofficeIntegration/http/endpoints/workspace/httpGetWorkspaceMembersOfWorkspace';

export type WorkspaceInfo = Awaited<ReturnType<typeof httpGetWorkspace.callEndpoint>> & {
  memberCount: number;
};

type CustomGetWorkspaceOptions = {
  workspaceId: string;
};

export const httpCustomGetWorkspaceInfo = mutationEndpoint({
  callEndpoint: async ({ workspaceId }: CustomGetWorkspaceOptions): Promise<WorkspaceInfo> => {
    const workspaceResult = await httpGetWorkspace.callEndpoint({ workspaceId });

    const workspaceMembersResult = await httpGetWorkspaceMembersOfWorkspace.callEndpoint({
      workspaceId,
    });

    return {
      ...workspaceResult,
      memberCount: workspaceMembersResult.page?.totalElements || 0,
    };
  },
});
